export enum TelegramNotifyQueryKeys {
	GetTelegramNotifySetting = 'telegramNotify.getTelegramNotifySetting',
}

export enum TelegramNotifyMutationKeys {
	UpdateTelegramNotifySetting = 'telegramNotify.updateTelegramNotifySetting',
}
